import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidBuildingIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 20h-1V3c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v17H3c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1s-.4-1-1-1ZM9 6h1c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1Zm-1 5c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1Zm7 9H9v-5c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v5Zm0-8h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1Zm0-4h-1c-.6 0-1-.4-1-1s.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1Z"/>
  </SvgIcon>
}

export default SolidBuildingIcon
